import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import { HOOK_CANVAS__static_mask } from '@/pages/page_generation/_archive/other/image/image_mask/_hooks/HOOK_CANVAS__mask_static';
import { HOOK_CANVAS__from_image } from '@/pages/page_generation/layouts/_base/HOOK_CANVAS__from_image';
import { HOOK_IMAGE__get_image_mask_for } from '@/utils/_methods/FN_IMAGE__get_image_mask_for';
import { assert_not_null, assert_true } from '@shared/asserts/utils_asserts';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_IMAGE_OVERLAY__mask({ field }: PROPS) {
  /*
   * STATE
   */
  const ref_canvas_mask_static = use_ref_with_fallback(ENUM__html_ref_stub.CANVAS);
  const { render_static_mask } = HOOK_CANVAS__static_mask();

  const field_mask = HOOK_IMAGE__get_image_mask_for(field);
  const canvas_image_mask = HOOK_CANVAS__from_image(field_mask.asset);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (canvas_image_mask.is_zero_size()) return;
    if (!field.image__is_initialized) return;

    const { width, height } = canvas_image_mask;
    const canvas_element = ref_canvas_mask_static.current;

    const context_image_mask = canvas_image_mask.getContext('2d', { willReadFrequently: true });
    assert_not_null(context_image_mask);

    const image_mask_data = context_image_mask.getImageData(0, 0, width, height);

    // Execute the static render calculation instantly without intervals
    render_static_mask(canvas_element, image_mask_data);
  }, [canvas_image_mask, field]);

  /*
   * METHODS
   */

  function get_target_aspect_ratio() {
    assert_true(field.image__is_initialized);
    return field.asset.image_size.aspect_ratio;
  }

  /*
   * HTML
   */
  if (field_mask.meta.field_id == field.meta.field_id) return null;
  if (field_mask.is_stub()) return null;
  if (!field.image__is_initialized) return null;

  return (
    <canvas
      className={`absolute top-0 left-0 pointer-events-none size-full opacity-60 aspect-[${get_target_aspect_ratio()}] rounded`}
      ref={ref_canvas_mask_static}
    />
  );
}
